// extracted by mini-css-extract-plugin
module.exports = {"heading":"e_5sb","title":"e_6sb","toTopButton":"e_7sb","toTopButtonIcon":"e_8sb"};